import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedItems,
  handleSetSelectedFilterIds,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleChangeSortBy,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { newspaperFiltersInitialState } from './initialState/newspaperInitialState';

export { newspaperFiltersInitialState as filtersInitialState };
export const newspaperContentInitialState = {
  filters: newspaperFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const newspaperContentSlice = createSlice({
  name: 'newspaperContentSlice',
  initialState: newspaperContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, newspaperFiltersInitialState);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = newspaperFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, newspaperFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = newspaperContentSlice.actions;
